import { render } from "./AvatarFilter.vue?vue&type=template&id=5e00a9fb"
import script from "./AvatarFilter.vue?vue&type=script&lang=js"
export * from "./AvatarFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__